import { newToolFilterOAuthMcp } from "../oauth.ts";

export const cloudflareDeveloperPlatformMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://developers.cloudflare.com/favicon.png",
  url: "https://bindings.mcp.cloudflare.com/mcp",
  label: "Cloudflare Developer Platform",
});
